<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $t('message.currentTreatments') }}
                    </h3>
                </div>
            </div>

            <div class="card-body" v-if="can">
                <h3 class="card-title text-center mb-0">
                    {{$tc('message.medicalFiles',1)}} :{{dossier}}
                </h3>
                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="traitementsACreer-group"
                                        :label="$t('message.description')"
                                        label-for="traitementsACreer">
                                    <b-form-textarea
                                            id="traitementsACreer"
                                            :value="traitementACreer"
                                            v-model="$v.traitementsACreer.$model"
                                            @keydown="clearErrorField('traitements')"
                                            :state="$v.traitementsACreer.$dirty ? !(errorshasField('traitements') || $v.traitementsACreer.$error) : null"

                                    ></b-form-textarea>
                                    <b-form-invalid-feedback v-if="errorshasField('traitements')">
                                        {{getErrorsField('traitements')}}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('traitements')" style="color:red">
                                    {{getErrorsField('traitements')}}
                                    </span>
                                    <b-form-invalid-feedback v-if="$v.traitementsACreer.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.traitementsACreer.minLength">
                                        {{ $t('message.minCharacters', { n: 4 }) }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>
                        </b-row>
                    </b-container>
                </b-form>
            </div>
            <div class="card-body">
                <h3 class="card-title text-center mb-0">
                    List  {{ $t('message.currentTreatments') }}
                </h3>
                <b-col sm="12">
                    <b-row >
                        <template v-if="rows">
                            <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                    class="mb-3"
                                    aria-controls="generals-table"
                            ></b-pagination>


                            <b-table
                                    id="generals-table"
                                    primary-key="id"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    selectable
                                    select-mode="single"
                                    borderless
                                    responsive
                                    striped
                                    hover
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    @row-selected="rowSelected"
                                    :fields="fields"
                                    :items="traitements"
                            >
                            <template v-slot:cell(description)="data">
                                <p class="mb-0" v-html="data.item.description"></p>
                            </template>
                                <!-- A virtual compositeumn for actions -->
                                
                            </b-table>

                            <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                    aria-controls="generals-table"
                            ></b-pagination>
                        </template>

                        <template v-else>
                            <div class="card">
                                <div class="card-body text-xs-center">
                                    <p class="card-text">
                                        {{ $t('message.noResults') }}
                                    </p>
                                </div>
                            </div>
                        </template>
                    </b-row>
                </b-col>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import _ from 'lodash';
    import { required,minLength } from 'vuelidate/lib/validators';

    export default {
        name: "AddTreatment",

        computed: {
            ...mapGetters(['errors', 'file',
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole',
            ]),
            mFile: function() {
                return this.file;
            },
            can: function (){
                if (this.hasAdminRole || this.hasMedecinControleRole){
                    return true;
                }else{
                    return this.hasPraticienRole || this.hasAssistante;
                }
            },
            dossier:function () {
                if ( typeof  this.mFile== 'object'){
                    return  this.file.numero_dossier;
                }
                return "";
            },
            traitements:function () {
                let tArray = [];
                if ( typeof  this.mFile.traitements == 'object'){
                    _.forEach(this.mFile.traitements, function(traitement) {
                        let t = {};
                        t.id = traitement.id;
                        t.slug = traitement.slug;
                        t.isAuthor = traitement.isAuthor;
                        t.description = traitement.description;
                        t.datePrescription = traitement.created_at;
                        tArray.push(t);
                    });
                }
                return tArray;
            },
            rows: function() {
                if ( typeof  this.mFile.traitements== 'object'){
                    return  this.file.traitements.length;
                }
                return 0;
            },
        },
        data() {
            return {
                show: true,
                file_id: this.$route.params.file,
                traitementsACreer:"",
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'description',
                        label: this.$i18n.t('message.description', 1),
                    },
                    {
                        key: 'datePrescription',
                        label: this.$i18n.t('message.prescriptionDate'),
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            rowSelected(items) {
                this.$router.push({ name: 'treatment', params: { treatment: items[0].slug } });
            },

            removeTraitement(slug) {
                let self = this;
                let args = {
                    treatment:slug
                };

                let successMessage = this.$i18n.t('message.currentTreatmentsDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteActuelTraitement', { args, index: slug, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal-' + slug);
                });
            },

            getFile() {
                let args = {
                    file: this.file_id
                };
                this.$store.dispatch("getMedicalFile", { args });
            },

            onSubmit: function(evt) {
                evt.preventDefault();
                this.$v.$touch();


                if (!this.$v.$invalid) {
                    let args = {
                        dossier_medical_id: this.file.id,
                        traitements: this.traitementsACreer
                    };

                    let successMessage = this.$i18n.t('message.currentTreatmentsCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createTraitementActuel', {args, errorMessages, successMessage}).then(() => {
                        this.traitementsACreer = "";
                    });
                }
            },
            onReset: function(evt) {
                //
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            },
        },

        mounted() {
            this.getFile();
        },

        validations: {
            traitementsACreer: {
                required,
                minLength:minLength(4)
            }
        }
    }
</script>

<style scoped>

</style>